import { FORTA_BLUE, FORTA_ERROR, FORTA_WHITE } from '../../../../../utils/colors';

export const SYMPTOMS_INTERVENTIONS_ROOT_SX = {
  flexGrow: 1,
  display: 'flex',
  flexDirection: 'column',
  gap: 3,
  mt: 3,
};

export const LEGACY_SECTION_SX = {
  position: 'relative',
  borderRadius: '10px',
  boxShadow: 'none',
};

export const FIRST_SECTION_SPACING_SX = {
  mb: 0,
};

export const SECTION_ENABLED_SX = {
  opacity: 1,
};

export const SECTION_DISABLED_SX = {
  opacity: 0.5,
};

export const LEGACY_SECTION_CONTENT_SX = {
  pt: 2,
};

export const LEGACY_SECTION_TITLE_SX = {
  fontSize: 21,
  fontWeight: 500,
  color: FORTA_BLUE.primary,
  textAlign: 'left',
};

export const LEGACY_SECTION_SUBTITLE_SX = {
  textAlign: 'left',
  fontWeight: 500,
  mt: 0.5,
  mb: 3,
};

export const SECTION_ERROR_SX = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  mt: 1,
  mb: 2,
};

export const SECTION_ERROR_TEXT_SX = {
  textAlign: 'left',
  color: FORTA_ERROR,
  ml: 1,
};

export const CHECKLIST_GRID_SX = {
  flexGrow: 1,
};

export const CHECKLIST_GROUP_SX = {
  p: 2,
};

export const CHECKLIST_GROUP_SUBTITLE_SX = {
  textAlign: 'left',
  fontWeight: 500,
  mb: 2,
};

export const CHECKLIST_COLUMN_SX = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
};

export const CHECKLIST_DIVIDER_COLUMN_SX = {
  ...CHECKLIST_COLUMN_SX,
  borderRightWidth: { xs: 0, md: '1px' },
  borderRightStyle: 'solid',
  borderRightColor: FORTA_BLUE.light2,
};

export const CHECKLIST_OFFSET_COLUMN_SX = {
  ...CHECKLIST_COLUMN_SX,
  pl: { xs: 0, md: 3 },
};

export const CHECKLIST_OFFSET_DIVIDER_COLUMN_SX = {
  ...CHECKLIST_DIVIDER_COLUMN_SX,
  pl: { xs: 0, md: 3 },
};

export const CHECKLIST_OPTION_ROW_SX = {
  display: 'flex',
  justifyContent: 'space-between',
  pr: 3,
  alignItems: 'center',
  mb: 2,
};

export const CHECKLIST_TOOLTIP_SX = {
  borderRadius: '8px',
  padding: '12px',
};

export const INFO_ICON_STYLE = {
  color: FORTA_BLUE.primary,
};

export const LEGACY_OTHER_FIELD_WRAPPER_SX = {
  mt: 2,
};

export const LEGACY_OTHER_FIELD_LABEL_SX = {
  textAlign: 'left',
  fontWeight: 700,
  mb: 1,
};

export const CHECKLIST_TOOLTIP_BACKGROUND = FORTA_WHITE;
export const SECTION_ERROR_COLOR = FORTA_ERROR;
